<template>
  <div id="app">
    <router-view />
    <Toaster class="pointer-events-auto" />
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useAuthStore } from '@/stores/auth'
import { useTheme } from '@/composables/useTheme'
import { Toaster } from '@/components/ui/sonner'
import { syncPushSubscription, isPushSupported } from '@/services/pushNotifications'
import 'vue-sonner/style.css' // vue-sonner v2 requires this import

const authStore = useAuthStore()
const { initTheme } = useTheme()

onMounted(async () => {
  // Initialize theme
  initTheme()

  // Initialize auth state on app start
  await authStore.initializeAuth()

  // Sync push subscription if user is authenticated and push is supported
  if (authStore.isAuthenticated && isPushSupported()) {
    syncPushSubscription().catch(err => {
      console.warn('Failed to sync push subscription:', err)
    })
  }
})
</script>